export enum ApproachOrWithDrawl { 
    Approach = 1,
    Withdraw = 3
    }